function updateProgressBar() {
  var article = document.querySelector('#articleMain');
  var progressBar = document.getElementById('progressBar');

  // Calcula a altura do scroll em relação à altura total do artigo
  var scrollDistance = window.scrollY || document.documentElement.scrollTop;
  var articleHeight = article.clientHeight - document.documentElement.clientHeight;
  // console.log('*** Articleheight: ', articleHeight);

  var scrolledPercentage = (scrollDistance / articleHeight) * 100;
  // console.log('*** scrolledPercentage: ', scrolledPercentage);

  // Atualiza a largura da barra de progresso
  progressBar.style.width = scrolledPercentage + '%';

}

// Adiciona o evento de scroll para atualizar a barra de progresso
window.addEventListener('scroll', updateProgressBar);


document.addEventListener("DOMContentLoaded", function () {
  const galleries = document.querySelectorAll('.slider-wrapper');

  if (galleries) {
    galleries.forEach((gallery, galleryIndex) => {
      const slides = gallery.querySelectorAll('.slider > .wp-block-gallery > .wp-block-image');
      const nextButton = gallery.querySelector('.next');
      const prevButton = gallery.querySelector('.prev');
      const dotsContainer = gallery.querySelector('.slider-dots');
      const title = document.title + '- Galeria';
      const location = window.location.href;
      let currentIndex = 0;

      // console.log('*** Title:', title);
      // console.log('*** Location:', location);

      // Create dots
      slides.forEach((slide, index) => {
        const dot = document.createElement('button');
        dot.classList.add('dot');
        dot.dataset.index = index;
        dotsContainer.appendChild(dot);
      });

      const dots = dotsContainer.querySelectorAll('.dot');
      dots[currentIndex].classList.add('active');

      function showSlide(index) {
        slides.forEach((slide, i) => {
          slide.style.display = i === index ? 'block' : 'none';
        });
        dots.forEach(dot => dot.classList.remove('active'));
        dots[index].classList.add('active');
      }

      function nextSlide() {
        currentIndex = (currentIndex + 1) % slides.length;
        gtag('event', 'page_view', {
          page_title: title,
          page_location: location,
        });
        showSlide(currentIndex);
      }

      function prevSlide() {
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
        gtag('event', 'page_view', {
          page_title: title,
          page_location: location,
        });
        showSlide(currentIndex);
      }

      nextButton.addEventListener('click', nextSlide);
      prevButton.addEventListener('click', prevSlide);
      dots.forEach(dot => {
        dot.addEventListener('click', function () {
          currentIndex = parseInt(this.dataset.index);
          showSlide(currentIndex);
        });
      });

      showSlide(currentIndex);
    });
  }
});




// Observer Feature Video
// document.addEventListener("DOMContentLoaded", function () {
//   var iframeVideo = document.querySelector('#feature-video > iframe');
//   var wasFixed = false; // Controla se o iframe foi fixado

//   console.log('***', iframeVideo);

//   var observer = new IntersectionObserver(function (entries) {
//     entries.forEach(entry => {
//       // Quando o iframe não está visível e ainda não foi fixado
//       if (!entry.isIntersecting && !wasFixed) {
//         iframeVideo.classList.add('fixed-video');
//         wasFixed = true; // Marca que o iframe foi fixado
//       } else if (entry.isIntersecting && wasFixed) {
//         iframeVideo.classList.remove('fixed-video');
//         wasFixed = false; // Marca que o iframe não está mais fixado
//       }
//     });
//   }, {
//     root: null, // observa em relação ao viewport
//     rootMargin: '0px',
//     threshold: [0.1] // Menos sensível que 0.01
//   });

//   // Observa o iframe
//   observer.observe(iframeVideo);
// });

// window.addEventListener('scroll', function () {
//   // O callback do scroll é apenas para garantir que o iframe seja fixado
//   // apenas quando necessário, dependendo do contexto mais complexo
//   var iframeRect = document.querySelector('#feature-video > iframe').getBoundingClientRect();
//   if (iframeRect.top > window.innerHeight && !wasFixed) {
//     iframe.classList.add('fixed-video');
//     wasFixed = true;
//   } else if (iframeRect.top <= window.innerHeight && wasFixed) {
//     iframe.classList.remove('fixed-video');
//     wasFixed = false;
//   }
// });